/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Notes_Delete_ErrorInputs */

const en_notes_delete_error = /** @type {(inputs: Notes_Delete_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The note could not be deleted: ${i?.message}`)
};

const pt_br2_notes_delete_error = /** @type {(inputs: Notes_Delete_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Não foi possível excluir a anotação: ${i?.message}`)
};

/**
* | output |
* | --- |
* | "The note could not be deleted: {message}" |
*
* @param {Notes_Delete_ErrorInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notes_delete_error = /** @type {((inputs: Notes_Delete_ErrorInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_Delete_ErrorInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notes_delete_error(inputs)
	return pt_br2_notes_delete_error(inputs)
});